import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditNoticeboardCategoryLayer from "../components/EditNoticeboardCategoryLayer";
 
 
const EditNoticeboardCategoryPage = () => {
  return (
    <>
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Noticeboard Category  </h5><Breadcrumb title="Edit Noticeboard Category" /></div>
 
        {/* CalendarMainLayer */}
        <EditNoticeboardCategoryLayer />
 
 
    </>
  );
};
 
export default EditNoticeboardCategoryPage;
 
 